export const OUTDATED_LINK = 'app.outdatedLink.button.href'
